module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/related/ko_4-e5cc7217e1ce4b97c877fffc1b4c6d6c.jpg";